import React from "react";
import styles from "./meter-selector.module.scss";
import { ConsumerType } from "../../../../model/energy-profile";
import { BeneficiaryItem } from "../../../../service/beneficiary-service";
import { MeterValidationResponse } from "../../buy-electricity/buy-electricity.types";
import { MeterTypeSelect } from "../meter-type-select";
import { InputMeterNumber } from "../input-meter-number";

export interface MeterSelectorProps {
	value: ConsumerType | null;
	onTypeChange: (type: ConsumerType) => void;
	meterValue: string;
	onMeterChange: (value: string) => void;
	onBeneficiarySelect: (beneficiary: BeneficiaryItem) => void;
	isValidating?: boolean;
	validationData?: MeterValidationResponse | null;
	validationError?: string;
	currencySymbol?: string;
	outstandingAmount?: number;
	hideSavedBeneficiaries?: boolean;
}

export const MeterSelector: React.FC<MeterSelectorProps> = ({
	value,
	onTypeChange,
	meterValue,
	onMeterChange,
	onBeneficiarySelect,
	isValidating,
	validationData,
	validationError,
	currencySymbol,
	outstandingAmount,
	hideSavedBeneficiaries,
}) => {
	const paymentType = value === ConsumerType.Prepaid ? "prepaid" : value === ConsumerType.Postpaid ? "postpaid" : null;

	return (
		<div className={styles.wrapper}>
			<MeterTypeSelect value={value} onChange={onTypeChange} />

			{value !== null && (
				<section className={styles.card}>
					<InputMeterNumber
						value={meterValue}
						onChange={onMeterChange}
						paymentType={paymentType}
						onBeneficiarySelect={onBeneficiarySelect}
						isValidating={isValidating}
						validationData={validationData}
						validationError={validationError}
						currencySymbol={currencySymbol}
						outstandingAmount={outstandingAmount}
						hideSavedBeneficiaries={hideSavedBeneficiaries}
					/>
				</section>
			)}
		</div>
	);
};
